import { createPortal } from 'react-dom';
import React from 'react';

export const AppToolbar = (props: {
  children: React.ReactNode;
}) => {
  const toolbarElement = document.getElementById('eitum-toolbar');
  
  if (!toolbarElement) {
    return null;
  }

  return createPortal(props.children, toolbarElement);
};
